// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.labSidebar {
  position: absolute !important;
  top: 95% !important;
  right: 95% !important;
}

.bottom-nav {
  background: transparent !important;
}

.labSidebar .iSpeedDial-fab {
  background-color: red;
}

/* MuiButtonBase-root MuiFab-root MuiFab-circular MuiFab-sizeLarge MuiFab-primary MuiFab-root MuiFab-circular MuiFab-sizeLarge MuiFab-primary MuiSpeedDial-fab css-7dv1rb-MuiButtonBase-root-MuiFab-root-MuiSpeedDial-fab */
`, "",{"version":3,"sources":["webpack://./src/modules/private/components/Sidebar/labSidebar.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,2NAA2N","sourcesContent":[".labSidebar {\r\n  position: absolute !important;\r\n  top: 95% !important;\r\n  right: 95% !important;\r\n}\r\n\r\n.bottom-nav {\r\n  background: transparent !important;\r\n}\r\n\r\n.labSidebar .iSpeedDial-fab {\r\n  background-color: red;\r\n}\r\n\r\n/* MuiButtonBase-root MuiFab-root MuiFab-circular MuiFab-sizeLarge MuiFab-primary MuiFab-root MuiFab-circular MuiFab-sizeLarge MuiFab-primary MuiSpeedDial-fab css-7dv1rb-MuiButtonBase-root-MuiFab-root-MuiSpeedDial-fab */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
